document.addEventListener('click', function (e) {
    const btn = e.target.closest('.wcl-author-block__toggle');
    if (!btn) return;

    const parent = btn.closest('.wcl-author-block');
    parent.classList.toggle('is-open');

    btn.textContent = parent.classList.contains('is-open')
        ? 'Show Less'
        : 'Read More';
});